import { postData } from "../../apis/api.helpers";
import apiUrl from "../../apis/api.url";

export const sendContactUs = (data:any)=>
    postData(apiUrl.CONTACTUS, data).then((res)=>res)